import styled from "styled-components";

export const CMDiv = styled.div`
  width: 90%;
  display: flex;
  max-width: 350px;
  align-itemns: flex-end;
  flex-direction: column;
  text-align: left;

  @media (min-width: 2000px) {
    max-width: 100vh !important;
  }

  & .account-type {
    @media (min-width: 2000px) {
      font-size: 3vh;
    }
  }

  & .google-button {
    @media (min-width: 2000px) {
      & div div div {
        justify-content:center;
        min-width: 6vh !important;
      }
      & div div div svg{
        margin-right:2vh;
      }
    }
  }

  & .apple-auth-btn svg g {
    @media (min-width: 2000px) {
     transform-origin: center;
     transform: scale(3.2);
     width:2vh;
    }
  }



  & .MuiFormControl-root input {
    width: 100% !important; 
  }

  & p {
    @media (min-width: 2000px) {
      font-size: 2vh;
    }
  }

  & label {
    color: #6e6d6d;
    @media (min-width: 2000px) {
        font-size: 3vh;
    }
    & input {
    @media (min-width: 2000px) {
        width:2vh !important;
        height:2vh !important;
    }
  }
  }
  & h4 {
    @media (min-width: 2000px) {
        font-size: 3vh;
    }
  }
  & a {
    @media (min-width: 2000px) {
        font-size: 2vh !important;
    }
  }
  & a img {
    @media (min-width: 2000px) {
        height: 20vh !important;
        width: 20vh !important;
        max-width:100% !important;
        max-height:100% !important;
    }
  }
  & input {
    color: #6e6d6d;
    @media (min-width: 2000px) {
        font-size: 3vh !important;
        height: auto !important;
    }
  }
  & select {
    color: #6e6d6d;
    @media (min-width: 2000px) {
        font-size: 3vh !important;
        height: auto !important;
    }
  }
  & button {
    @media (min-width: 2000px) {
        font-size: 3vh !important;
        height: auto !important;
        width: 10vh;
    }
  }
  & div {
    @media (min-width: 2000px) {
        font-size: 3vh !important;
        height: auto !important;
        max-height:100%;
        max-width:100%;
    }
    & input {
      @media (min-width: 2000px) {
        max-width:100%;
      }
    }
    & svg {
      @media (min-width: 2000px) {
        width: 2vh;
        height: 2vh;
        padding: 2vh;
    }
  



  & .password-field {
    & span {
      position: relative;
      width: 100%;
      background: transparent;
      justify-content: left;
    }
  }
  & .account-type {
    @media (min-width: 2000px) {
      font-size: 2vh;
    }
    @media (max-width: 767px) {
      display: none;
    }
  }
`;

export const CMLink = styled.div(props => ({
  position: 'absolute',
  top: '5vw',
  right: '15vw',
  
  
    "@media (max-width:768px)": {
      position:"relative",
      right: 0
    },
  

  
  
}));


export const BTN = styled.div(props => ({
  '& .btn_submit': {
    "@media (max-width:480px)": {
      width: '100%'
    },
  },
  '& button': {
    "@media (min-width:2000px)": {
      minHeight:"4vh",
      '& div span': {
        "@media (min-width:2000px)": {
          width: "auto !important",
          height:"auto !important"
        },
      },
    },
  },
}));

export const MainDiv = styled.div(props => ({

'& .App':{
  "@media (max-width:576px)": {
      minHeight: '450px',
      paddingTop:'0'
    },
    "@media (max-width:766px)": {
      paddingTop:'0',
      minHeight: '450px',
      marginBottom: '40px'
      
    },
    
}
}))

export const ButtonsContainer = styled.div(props => ({
  display: 'flex',
  gap: '10px',
  flexDirection: 'column',
  "& .resend_code_button" :{
    background: 'none',
    border: 'none',
    color: '#4090cd',
    font: 'inherit',
    padding: '0px',
    marginTop: '0px'
  },
  "& .resend_code_button::hover" :{
    border: 'none',
    color: 'blue',
    backgroundColor: 'transparent'
  }
}))

export const FormContainer = styled.div(props => ({
  width: '100%',
  '& .input_code':{
    width: '100%'
  },
  '& p':{
    color: 'gray',
     marginTop: '10px' 
  }

}))

export const CMContainer = styled.div(props => ({
  display: 'flex',
  maxWidth: '370px',
  flexDirection: 'column'
}));